import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { ReactNode } from "react";

export function shouldShowLegalNameHover(
  preferredName: string,
  legalName?: string | null,
): boolean {
  const legal = legalName?.trim() ?? "";
  return legal.length > 0 && legal !== preferredName.trim();
}

export function LegalNameHover({
  preferredName,
  legalName,
  children,
}: {
  preferredName: string;
  legalName?: string | null;
  children: ReactNode;
}) {
  if (!shouldShowLegalNameHover(preferredName, legalName)) {
    return children;
  }

  return (
    <TooltipProvider delayDuration={import.meta.env.MODE === "test" ? 0 : 200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex min-w-0 max-w-full">{children}</span>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          align="start"
          className="rounded-2xl border-0 bg-white px-4 py-3 shadow-lg"
        >
          <p className="font-body text-body-2 text-text-tertiary">
            {legalName?.trim()}
          </p>
          <p className="font-heading text-header-5 leading-[1.2] text-text-primary">
            {preferredName}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
